import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HeroSection() {
  const featuredComics = comics.filter(c => c.rating >= 4.7).slice(0, 5);

  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=epic%20Korean%20manhwa%20webtoon%20art%20style%20dramatic%20fantasy%20landscape%20with%20warm%20orange%20and%20amber%20tones%20cinematic%20lighting%20majestic%20composition%20abstract%20background%20with%20comic%20panel%20elements%20modern%20digital%20art%20vibrant%20colors&width=1920&height=1080&seq=hero-bg-manhwa-2026&orientation=landscape"
          alt="免费韩漫大全 - 韩国漫画在线阅读平台"
          className="w-full h-full object-cover object-top"
          title="免费韩漫大全 - 韩国漫画在线阅读平台"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight mb-6">
            韩国漫画的<strong className="text-primary-400 font-heading">无限世界</strong>
          </h1>
          <p className="text-base md:text-lg text-background-100/80 max-w-xl mx-auto mb-8 leading-relaxed">
            涵盖热血、恋爱、奇幻等全品类韩漫，无需注册即可在线阅读，每日更新最新章节。在这里发现你下一个最爱的韩国漫画。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/action"
              className="px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
            >
              开始阅读
            </Link>
            <Link
              to="/category/romance"
              className="px-8 py-3 border border-background-50/40 text-background-50 font-medium rounded-full hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
            >
              热门推荐
            </Link>
          </div>
        </div>

        <div className="mt-10 md:mt-14 w-full max-w-4xl mx-auto">
          <div className="flex items-center justify-center gap-4 md:gap-6 flex-wrap">
            {featuredComics.map((comic) => (
              <Link
                key={comic.id}
                to={`/article/${comic.id}`}
                className="group flex items-center gap-3 bg-background-50/10 backdrop-blur-sm border border-background-50/20 rounded-xl px-4 py-3 hover:bg-background-50/20 transition-all duration-300 cursor-pointer"
              >
                <div className="w-10 h-10 rounded-lg overflow-hidden flex-shrink-0">
                  <img src={comic.cover} alt={comic.title} className="w-full h-full object-cover" title={comic.title} />
                </div>
                <div className="text-left">
                  <p className="text-sm font-semibold text-background-50 whitespace-nowrap">{comic.title}</p>
                  <p className="text-xs text-background-100/60">{comic.category} · {comic.status}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}